import React from 'react';
// import PropTypes from 'prop-types';

// Components
import Banner from 'components/Banner/Banner';
// import ErrorBoundary from 'components/_shared/ErrorBoundary/ErrorBoundary';
// SVGs
// Constants
// Styles
import './AddOrg.css';

export default class AddMe extends React.Component {
  // Prop Types
  // ------------------------------------------------------------------------ //
  static propTypes = {};
  static defaultProps = {};

  // Constructor
  // ------------------------------------------------------------------------ //
  // constructor(props) {
  //   super(props);
  // }

  // Variables
  // ------------------------------------------------------------------------ //

  // Lifecycle methods
  // ------------------------------------------------------------------------ //

  // Event handlers
  // ------------------------------------------------------------------------ //

  // Class methods
  // ------------------------------------------------------------------------ //

  // Render methods
  // ------------------------------------------------------------------------ //
  render() {
    return (
      <div className="addMe">
        <section className={`addMe__hero`}>
          <h1>Interested in joining the Elevate <a target="_target" href="https://www.artworxla.org/elevate" className="addMe__network" rel="noopener noreferrer">network</a>? Join now and help LA's Opportunity Youth gain access to the creative economy.</h1>
        </section>
        <section className={`addMe__content`}>
          <h2>Whether your organization is a school, an organization, agency or a grantmaker, we'd love to connect! Send an email with some basic information about your organization to <a target="_target" href="https://www.artworxla.org/elevate" rel="noopener noreferrer">elevate@artworxLA.org</a> to get started.</h2>
          <h2>In future months, we will be hosting events to bring the network closer together and help members make valuable connections to improve how LA's Opportunity Youth are served.</h2>
        </section>
        <Banner />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AddOrg/AddOrg.js